



























































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { StepMixin, StepStoreMixin, StoreFileMixin, ErrorResponseMixin, PopupMixin } from '@mixin';
import { ProjectService } from '@store/service/ProjectService';
import CustomPlan from './CustomPlan.vue';


/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            projectService: {},
            maxFiles: 5,
            post: {
                files: [],
                owner: 'project',
                type: 'begroting-dekking',
            },
            planDataBegrotingHasData: false,
            planDataBegroting: [],
            planDataDekkingsplanHasData: false,
            planDataDekkingsplan: [],
        };
    },

    mixins: [
        StepMixin,
        StepStoreMixin,
        StoreFileMixin,
        ErrorResponseMixin,
        PopupMixin,
    ],

    components: {
        CustomPlan,
    },

    created() {
        this.post.id = this.current.id;
        this.prepareStoringFiles(this.post);
        this.projectService = new ProjectService(this.$store);
    },

    mounted() {
        // Begroting custom plan
        this.projectService.getPlanDataRows(this.store.id, 'begroting').then(response => {
            this.planDataBegroting = response.data;
            this.planDataBegrotingHasData = this.planDataBegroting.length > 0;
        });

        this.$watch(() => this.$refs.begrotingCustomPlan.hasData, (value) => {
            this.planDataBegrotingHasData = value;
        });

        // Dekkingsplan custom plan
        this.projectService.getPlanDataRows(this.store.id, 'dekkingsplan').then(response => {
            this.planDataDekkingsplan = response.data;
            this.planDataDekkingsplanHasData = this.planDataDekkingsplan.length > 0;
        });

        this.$watch(() => this.$refs.dekkingsplanCustomPlan.hasData, (value) => {
            this.planDataDekkingsplanHasData = value;
        });
    },


    computed: {
        customPlanDisabled() {
            const validPostFiles = this.post.files.filter(file => file.file).length !== 0;
            const validFiles = this.files.filter(file => file.href || file.downloading).length !== 0;

            return (validPostFiles || validFiles) &&
                !(this.planDataDekkingsplanHasData || this.planDataBegrotingHasData);
        },

        customPlansClass() {
            const classes = ['custom-plans'];

            if (this.customPlanDisabled)
                classes.push('is-disabled');

            return classes.join(' ');
        },
    },

    methods: {
        async onNext() {
            return await this.storeFiles(this.post)
        },

        clearFile(index) {
            this.removeFile(this.files[index]);
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Begroting extends Vue {}

